"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const trans_1 = require("@common/tsutils/trans");
const papaparse_1 = __importDefault(require("papaparse"));
const downloadFile_1 = __importDefault(require("@common/tsutils/downloadFile"));
const NUM_NEW_FIELDS = 5;
function dat2str(x) {
    if (x === null)
        return '';
    return x.toISOString().split('T')[0];
}
function bol2str(x) {
    if (x === null)
        return '';
    return x ? 'true' : 'false';
}
function num2str(x) {
    if (x === null)
        return '';
    return x + '';
}
function str2str(x) {
    return x || '';
}
class Template {
    constructor() {
        this.data = [];
    }
    build(samples) {
        this.addHeaders();
        samples.forEach(s => this.addRow(s));
    }
    addHeaders() {
        const row = [];
        const headers1 = [
            'code'
        ];
        const headers2 = [
            'name',
            'coll_date',
            'soil_type',
            'plant_year',
            'org_practises',
            'art_irrigation',
            'bio_methods',
            'density',
            'variety',
        ];
        headers1.forEach((h, i) => {
            let header = (0, trans_1.trans)('heatmap.metadata_items.' + h);
            if (i !== 0) {
                header += ' ' + Template.IGNORE;
            }
            row.push(header);
        });
        for (let i = 0; i < NUM_NEW_FIELDS; i++) {
            let header = (0, trans_1.trans)('heatmap.metadata_items.new_field');
            header += ' #' + (i + 1);
            row.push(header);
        }
        headers2.forEach((h, i) => {
            let header = (0, trans_1.trans)('heatmap.metadata_items.' + h);
            header += ' ' + Template.IGNORE;
            row.push(header);
        });
        this.data.push(row);
    }
    addRow(sample) {
        const part1 = [
            sample.code,
        ];
        const new_fields = (new Array(NUM_NEW_FIELDS)).map(() => '');
        const part2 = [
            sample.name,
            dat2str(sample.coreMetadata.date),
            num2str(sample.coreMetadata.soil_type_id),
            num2str(sample.coreMetadata.plant_year),
            bol2str(sample.coreMetadata.org_practises),
            bol2str(sample.coreMetadata.art_irrigation),
            bol2str(sample.coreMetadata.bio_methods),
            num2str(sample.coreMetadata.density),
            str2str(sample.coreMetadata.variety),
        ];
        this.data.push([
            ...part1,
            ...new_fields,
            ...part2,
        ]);
    }
    download() {
        const csv = papaparse_1.default.unparse(this.data);
        (0, downloadFile_1.default)(csv, 'metadata.csv', 'text/csv');
    }
}
exports.default = Template;
Template.IGNORE = '[IGNORE]';
